import React from "react";
import PropTypes from "prop-types";

const CountDown = props => {
  const [remainingTime, setRemainingTime] = React.useState(props.duration);

  React.useEffect(() => {
    const interval = setInterval(() => {
      setRemainingTime(remainingTime =>
        remainingTime - 1000 > 0 ? remainingTime - 1000 : 0
      );
    }, 1000);
    return () => clearInterval(interval);
  }, []);

  return (
    <span className="text-54">
      {new Date(remainingTime).toLocaleTimeString("en-EN", {
        minute: "2-digit",
        second: "2-digit"
      })}
    </span>
  );
};

CountDown.propTypes = {
  duration: PropTypes.number.isRequired
};

export default CountDown;
